export const READER_FONT_SIZE_DEFAULT = 18;